import { bind } from 'decko'
import { LiveElement } from 'live-node-list'
import Flickity from 'flickity'

export default class HeroBanner {
  /**
   * @type {LiveElement}
   */
  heroBanner = new LiveElement('.hero-banner')

  constructor() {
    this.registerListeners()
  }

  @bind
  registerListeners() {
    if (!this.heroBanner.item) {
      return
    }

    this.setupProductFlickitySlideshow()
  }

  @bind
  setupProductFlickitySlideshow() {
    const heroBanner = this.heroBanner.item.querySelector(
      '.hero-banner__slides',
    )

    var flkty = new Flickity(heroBanner, {
      cellAlign: 'left',
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
    })
  }
}
